module.exports = __webpack_public_path__ + "static/media/about-sumy-poster-1.ee356862.png";